import { lazy } from "react";

export const SiteMasterCredentialsListPageAsync = lazy(async function () {
  return import("./SiteMasterCredentialsListPage").then((module) => ({
    default: module.SiteMasterCredentialsListPage,
  }));
});
